import { render, staticRenderFns } from "./GroupCategoryList.vue?vue&type=template&id=2a430f46"
import script from "./GroupCategoryList.vue?vue&type=script&lang=js"
export * from "./GroupCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports